module.exports = __webpack_public_path__ + "img/HU10195664.dd465d38.svg";